import { render, staticRenderFns } from "./smallposter.vue?vue&type=template&id=711dd992"
import script from "./smallposter.vue?vue&type=script&lang=js"
export * from "./smallposter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports